/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Detail_BackInputs */

const en_cover_letters_detail_back = /** @type {(inputs: Cover_Letters_Detail_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to Cover Letters`)
};

const de_cover_letters_detail_back = /** @type {(inputs: Cover_Letters_Detail_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zu Anschreiben`)
};

const fr_cover_letters_detail_back = /** @type {(inputs: Cover_Letters_Detail_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour aux lettres de motivation`)
};

const es_cover_letters_detail_back = /** @type {(inputs: Cover_Letters_Detail_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver a cartas de presentación`)
};

const it_cover_letters_detail_back = /** @type {(inputs: Cover_Letters_Detail_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna alle lettere di presentazione`)
};

const nl_cover_letters_detail_back = /** @type {(inputs: Cover_Letters_Detail_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terug naar motivatiebrieven`)
};

const pl_cover_letters_detail_back = /** @type {(inputs: Cover_Letters_Detail_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powrót do listów motywacyjnych`)
};

const fi_cover_letters_detail_back = /** @type {(inputs: Cover_Letters_Detail_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takaisin saatekirjeisiin`)
};

const da_cover_letters_detail_back = /** @type {(inputs: Cover_Letters_Detail_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbage til ansøgningsbreve`)
};

const sv_cover_letters_detail_back = /** @type {(inputs: Cover_Letters_Detail_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tillbaka till personliga brev`)
};

/**
* | output |
* | --- |
* | "Back to Cover Letters" |
*
* @param {Cover_Letters_Detail_BackInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_detail_back = /** @type {((inputs?: Cover_Letters_Detail_BackInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Detail_BackInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_detail_back(inputs)
	if (locale === "fr") return fr_cover_letters_detail_back(inputs)
	if (locale === "es") return es_cover_letters_detail_back(inputs)
	if (locale === "it") return it_cover_letters_detail_back(inputs)
	if (locale === "nl") return nl_cover_letters_detail_back(inputs)
	if (locale === "pl") return pl_cover_letters_detail_back(inputs)
	if (locale === "fi") return fi_cover_letters_detail_back(inputs)
	if (locale === "da") return da_cover_letters_detail_back(inputs)
	if (locale === "sv") return sv_cover_letters_detail_back(inputs)
	return en_cover_letters_detail_back(inputs)
});